import {message} from '@sail/intl';

export const sectionCaption = message({
  id: 'mkt-ssr.startup_partners.hero_section.caption',
  defaultMessage: 'Stripe for Startups',
  description: 'Caption for the hero section',
});

export const sectionTitle = message<{partnerName: string}>({
  id: 'mkt-ssr.startup_partners.hero_section.title',
  defaultMessage: 'Stripe benefits for {partnerName}',
  description: 'Title for the hero section',
});

export const sectionBody = message({
  id: 'mkt-ssr.startup_partners.hero_section.body',
  defaultMessage:
    "Stripe is designed from the ground up for startups. We've built a fully integrated platform to give startups the fastest way to launch a company, experiment to find product-market fit, and grow and scale revenue.",
  description: 'Body text for the hero section',
});

export const ctaButtonText = message({
  id: 'mkt-ssr.startup_partners.hero_section.cta_button',
  defaultMessage: 'Apply now',
  description: 'Text for the CTA button in the hero section',
});
